import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67e5135f&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e5135f')) {
      api.createRecord('67e5135f', component.options)
    } else {
      api.reload('67e5135f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67e5135f&lang=pug", function () {
      api.rerender('67e5135f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultant/material/filter/index.vue"
export default component.exports